<div [id]="htmlId()" class="external-link-wrapper" [style.display]="isVisible() ? 'flex' : 'none'">
  @if (properties.text) {
    <div
      [ngClass]="[properties.style.toLowerCase(), 'preserve-newlines']"
      class="external-link-text"
      [style]="textStyle()">
      {{ properties.text }}
    </div>
  }
  @if (properties.url && href()) {
    @if (form().disabled) {
      <button type="button" [disabled]="form().disabled" class="link-target link-opener">
        <div class="icon-safe-zone">
          <mat-icon class="icon">open_in_new</mat-icon>
        </div>
        <span>{{ translateService.instant('liveforms-editor.external-link-item.open-link') }}</span>
      </button>
    } @else {
      <a
        [href]="href()"
        target="_blank"
        rel="noopener noreferrer"
        type="button"
        role="button"
        class="link-target link-opener">
        <div class="icon-safe-zone">
          <mat-icon class="icon">open_in_new</mat-icon>
        </div>
        <span>{{ translateService.instant('liveforms-editor.external-link-item.open-link') }}</span>
      </a>
    }
  } @else {
    <span [ngClass]="['link-target', properties.style.toLowerCase(), 'preserve-newlines']">{{ properties.text }}</span>
  }
</div>
